"use client";

import React from "react";
import { useTranslation } from "@/lib/i18n/LanguageContext";

/**
 * Renders a standalone ` & ` as the spelled-out conjunction of the active
 * locale. Source strings keep the ` & ` separator so the wording stays
 * centralised here instead of in every translation constant.
 */
export function WithAmp({ text }: { text: string }) {
  const { locale } = useTranslation();
  // Arabic "و" joins the next word (no space), except before Latin script.
  if (locale === "ar") return <>{text.replace(/\s&\s(?=(.))/g, (_, next: string) => (/[\u0600-\u06FF]/.test(next) ? " و" : " و "))}</>;
  const word = ({ de: "und", en: "and", da: "og", uk: "та", ru: "и", vi: "và", es: "y" } as const)[locale];
  return <>{text.replace(/\s&\s/g, ` ${word} `)}</>;
}
